import { Component, OnInit, OnDestroy, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';

import { Button } from '../../../ui/button/button';
import { Modal } from '../../../../core/services/modal';
import { Subject, takeUntil } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-otp-modal',
  standalone: true,
  imports: [Button, CommonModule, ReactiveFormsModule, NgOtpInputModule, TranslatePipe],
  templateUrl: './otp-modal.html',
  styleUrls: ['./otp-modal.css']
})
export class OtpModal implements OnInit, OnDestroy {
  @Input() options!: any;
  private destroy$ = new Subject<void>();

  timer = signal<number>(60);
  intervalId: any;
  isOtpComplete = false;

  otpForm = new FormGroup({
    otp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
  });

  constructor(private modalService: Modal) { }

  ngOnInit() {
    this.startTimer();

    // Automatically check OTP completeness
    this.otpForm
      .get('otp')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(value => this.isOtpComplete = (value || '').length === 6);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.destroy$.next();
    this.destroy$.complete();
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.timer.set(60);
    this.intervalId = setInterval(() => {
      if (this.timer() > 0) {
        this.timer.update((v) => v - 1);
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  /** Clear OTP field when resending */
  resendCode() {
    if (this.timer() === 0) {
      this.otpForm.get('otp')?.reset();
      this.startTimer();

      console.log('Resend code triggered')
    }
  }

  /** Called when user clicks verify button */
  submitOtp() {
    const code = this.otpForm.value.otp ?? '';
    const isValid = this.otpForm.valid && code.length === 6;
    // console.log(isValid, code, this.otpForm.valid)

    if (isValid) {
      // Notify parent about valid OTP
      //Handle OTP verfication API here and On otp validation successful send the response to parent. isValid
      this.options?.onSubmitOtp?.(isValid);
    } else {
      console.warn('Invalid OTP');
      this.otpForm.get('otp')?.setErrors({ invalid: true });
    }
  }

  onOtpChange(value: string) {
    this.otpForm.get('otp')?.setValue(value);
  }

  close() {
    this.modalService.close();
  }

  get formattedTimer(): string {
    const minutes = Math.floor(this.timer() / 60);
    const seconds = this.timer() % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
